<template>
  <!-- 活动规则弹窗，注意父容器设置为整个游戏详情页，使其始终居中显示 -->
  <section class="activity_rule_wrapper" :class="displayLayout">
    <p class="activity_rule_entry" @click="showRulesPopup">
      {{ $t('luckyDraw.rules_title') }}
    </p>

    <van-popup
      v-model="showPopup"
      position="center"
      :close-on-click-overlay="true"
      get-container=".games-detail-page"
      :class="['draw-rules-popup', displayLayout, inPopup ? 'popup' : '']"
      :style="{ background: bgColor }"
      @closed="close"
    >
      <div
        class="sticky-top-bar"
        @click="close"
        :style="{ background: bgColor }"
      >
        <div class="cross-icon-wrapper"><span>×</span></div>
      </div>
      <p class="title">{{ $t('luckyDraw.rules_title') }}</p>
      <div class="desc" v-html="rulesText"></div>
      <div class="sticky-bottom-bar" :style="{ background: bgColor }"></div>
    </van-popup>
  </section>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { trackClickRules } from '@/pages/Activity/firebase'
  import { checkIsColor } from '@/utils/tool.js'

  export default {
    name: 'activity-rule',
    props: {
      page: String,
      inPopup: Boolean,
      rulesText: String,
      ruleBgColor: String,
    },
    data() {
      return {
        showPopup: false,
      }
    },
    computed: {
      ...mapGetters(['displayLayout']),
      ...mapState(['region']),
      bgColor() {
        return (checkIsColor(this.ruleBgColor) && this.ruleBgColor) || '#6c3cf8'
      },
    },
    methods: {
      close() {
        this.showPopup = false
      },
      showRulesPopup() {
        trackClickRules(this.page)
        this.showPopup = true
      },
      formatTime(timestamp, region, format) {
        return dayjs(timestamp).locale(region).format(format)
      },
    },
  }
</script>

<style scoped lang="scss">
  section.activity_rule_wrapper {
    font-weight: 400;
    .activity_rule_entry {
      width: max-content;
      margin: 0 auto;
      color: #fff;
      text-decoration: underline;
      text-align: center;
      font-size: 33px;
      line-height: 39px;
    }
  }
  .draw-rules-popup.van-popup {
    border-radius: 12px;
    max-height: 1400px;
    width: 80vw;
    background-color: #6c3cf8;
    font-family: 'Noto Sans' !important;
    @include scrollingBar($barWidth: 8px, $barHeight: 8px);
    .sticky-top-bar {
      top: 0;
      position: sticky;
      width: 100%;
      height: 125px;
      .cross-icon-wrapper {
        display: block;
        width: 74px;
        height: 74px;
        position: absolute;
        right: 25px;
        top: 25px;
        text-align: center;
        font-size: 74px;
        line-height: 74px;
      }
    }
    .sticky-bottom-bar {
      position: sticky;
      bottom: 0;
      width: 100%;
      height: 125px;
    }
    * {
      color: #fff;
    }
    .title {
      font-size: 48px;
      line-height: 64px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 20px;
    }
    .desc {
      padding: 0 72px 20px;
      font-size: 36px;
      line-height: 48px;
      margin-bottom: 30px;
      word-break: break-all;
      font-weight: 300;
      & > p {
        margin-bottom: 15px;
      }
    }
    ::v-deep table {
      box-sizing: border-box;
      border-collapse: collapse;
      margin: 20px 0 32px;
      width: 100% !important;
      tbody tr:first-of-type > td {
        font-weight: bold;
      }
      td {
        border-width: 2px; // 注意：不要设置更小的值，否则经过 vw 转换后在 ios 设备上可能显示不出来
        border-style: solid;
        border-color: #fff;
      }
    }
    &.gt-layout {
      max-height: 970px;
      // .sticky-top-bar {
      //   height: 80px;
      //   .cross-icon-wrapper {
      //     top: 3px;
      //     right: 15px;
      //   }
      // }
      // .sticky-bottom-bar {
      //   height: 80px;
      // }
    }
  }

  section.activity_rule_wrapper.desktop-layout {
    .activity_rule_entry {
      font-size: 12.6px;
      line-height: 15px;
    }
  }
  .draw-rules-popup.desktop-layout {
    border-radius: 4.6px;
    max-height: 537px;
    width: 331px;
    @include scrollingBar($barWidth: 4px, $barHeight: 8px);
    .sticky-top-bar {
      top: 0;
      position: sticky;
      width: 100%;
      height: 48px;
      .cross-icon-wrapper {
        display: block;
        width: 28.4px;
        height: 28.4px;
        position: absolute;
        right: 9.6px;
        top: 9.6px;
        text-align: center;
        font-size: 28.4px;
        line-height: 28.4px;
      }
    }
    .sticky-bottom-bar {
      position: sticky;
      bottom: 0;
      width: 100%;
      height: 48px;
    }
    .title {
      font-size: 18.4px;
      line-height: 24.6px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 7.7px;
    }
    .desc {
      padding: 0 27px 7px;
      font-size: 12px;
      line-height: 18.4px;
      margin-bottom: 11.5px;
      word-break: break-all;
      font-weight: 300;
      p {
        margin-bottom: 5px;
      }
    }
    ::v-deep table {
      box-sizing: border-box;
      border-collapse: collapse;
      margin: 8px 0 12px;
      width: 100%;
      tbody tr:first-of-type > td {
        font-weight: bold;
      }
      td {
        border-width: 0.5px;
        border-style: solid;
        border-color: rgba(255, 255, 255, 0.8);
      }
    }
  }
</style>
